import { VIEWER_URL } from '@vindr/services/constants/study.constant';
import { useState } from 'react';

export type Iframe = [
  { open: boolean; url: string },
  (study_instance_uid: string, modality?: string | string[]) => void,
  () => void,
  (study_instance_uid: string, isOpen?: boolean) => void
];

const useSetIframe = (): Iframe => {
  const [iframeState, setIframeState] = useState({
    open: false,
    url: null,
  });

  const setOpenIframe = (
    study_instance_uid: string,
    modality: string | string[] = null
  ) => {
    if (!study_instance_uid) return setIframeState({ open: true, url: null });

    setIframeState({
      open: true,
      url:
        VIEWER_URL +
        `/${
          modality === 'SM' || modality.includes('SM')
            ? 'microscopy'
            : 'default'
        }/?StudyInstanceUIDs=${study_instance_uid}`,
    });
  };

  const setCloseIframe = () => {
    setIframeState({ open: false, url: null });
  };

  const setToggleIframe = (study_instance_uid: string, isOpen?: boolean) => {
    if (isOpen === true || (isOpen === undefined && iframeState.open)) {
      setCloseIframe();
    } else {
      setOpenIframe(study_instance_uid);
    }
  };

  return [iframeState, setOpenIframe, setCloseIframe, setToggleIframe];
};

export default useSetIframe;
